import { colors } from '@airwallex/global';
var state = {
  default: colors.greys[40],
  success: colors.greens[70],
  informational: colors.greys[70],
  warning: colors.oranges[70],
  critical: colors.reds[70],
  active: colors.ultraViolets[70]
};
var start = "".concat(state.success, " 100%");
var v = {
  success: "linear-gradient(0deg, ".concat(state.success, " 20%, ").concat(start, ")"),
  error: "linear-gradient(0deg, ".concat(state.critical, " 20%, ").concat(start, ")"),
  active: "linear-gradient(0deg, ".concat(state.active, " 20%, ").concat(start, ")")
};
var h = {
  success: "linear-gradient(-90deg, ".concat(state.success, " 40%, ").concat(start, ")"),
  error: "linear-gradient(-90deg, ".concat(state.critical, " 40%, ").concat(start, ")"),
  active: "linear-gradient(-90deg, ".concat(state.active, " 40%, ").concat(start, ")")
};
export var timelineTheme = {
  color: {
    default: state.default,
    success: state.success,
    informational: state.informational,
    warning: state.warning,
    critical: state.critical,
    active: state.active
  },
  connector: {
    horizontal: {
      completed: "".concat(h.success),
      current: "".concat(h.active),
      review: "".concat(h.active),
      rejected: "".concat(h.error)
    },
    vertical: {
      completed: "".concat(v.success),
      current: "".concat(v.active),
      review: "".concat(v.active),
      rejected: "".concat(v.error)
    }
  }
};